import { QueryParamsType } from "src/types/query-params";
import { useSwrRequest } from "../useSwrRequest";
import qs from "qs";
import useRequest from "../useRequest";

export const useDepartments = (query: Record<string, QueryParamsType>) => {
  const url = `/departments?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
  return {
    departments: (data as any[]) || [],
    mutate,
    isLoading,
    error,
    ...rest,
  };
};
